import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(theme => ({
    container: {
        '@media (min-width: 768px)': {
            width: '768px',
        },
        textAlign: 'center',
        padding: '12px 12px 0 12px',
        '& p': {
            marginBottom: '0',
        },
    },
    navLogo: {
        height: '24px',
        width: '24px',
        textAlign: 'left',
        display: 'block',
    },
    heading: {
        ...theme.typographyPresets.titleSmallBold,
        ...theme.fontColors.light,
        marginTop: '64px',
    },
    artistImg: {
        height: '180px',
        width: '180px',
        marginTop: '24px',
        borderRadius: '8px',
        objectFit: 'cover',
    },
    artistName: {
        ...theme.typographyPresets.titleLargeBlack,
        ...theme.fontColors.light,
        marginTop: '10px',
        lineHeight: '1',
    },
    countdownContainer: {
        background: theme.utils.convertHexToRGBA('#000000', 0.1),
        margin: '45px -12px 0 -12px',
        padding: '20px 0',
        '& span': {
            ...theme.typographyPresets.titleMediumLight,
            ...theme.fontColors.light,
        },
    },
    countdownTitle: {
        color: theme.colors.white,
        lineHeight: 1.57,
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        fontSize: 14,
        display: 'block',
    },
    disabledBg: {
        backgroundImage: `linear-gradient(to bottom, ${theme.colors.light.darkgrey}, ${theme.colors.dark.dark4})`,
    },
    liveBg: {
        backgroundImage: `linear-gradient(to bottom, ${theme.colors.brand.yellow}, ${theme.colors.brand.pink})`,
    },
    grayscale: {
        filter: 'grayscale(1)',
        WebkitFilter: 'grayscale(1)',
    },
}))
